import $ from "jquery";
import { GetGroup, pergola } from "../3d-configurator";
import { raycastItem } from "../raycast";
import { state } from "../settings";
import { lastHeatersForRemove, spansHeaters } from "./subSystemHeaters";
import { lastScreenForRemove, spansScreen } from "./subSystemScreen";

export function initHeaters() {
  state.heatersUrl.forEach((heater) => {
    pergola.spanHeater.objects.forEach((span) => {
      if (span.side === heater.side && span.number === heater.spanNumber) {
        // const activeSystem = span.systems.find(
        //   (systemSpan) => systemSpan.type === heater.type
        // );
        // console.log(span, activeSystem, "active system");

        // activeSystem.active = true;
        span.active = true;
        span.isSystemSet = true;
        pergola.changeObjectVisibility(true, span.heater.object);
      }
    });
  });

  pergola.update();
}

export function removeFromUrlHeatersBySide(side) {
  for (const heater of state.heatersUrl) {
    if (heater.side === side) {
      state.heatersUrl.delete(heater);
    }
  }
}

export function removeFromUrlHeater(side, spanNumber) {
  for (const heater of state.heatersUrl) {
    if (heater.side === side && heater.spanNumber === spanNumber) {
      state.heatersUrl.delete(heater);
    }
  }
}

export function removeAllFromUrlHeater() {
  for (const heater of state.heatersUrl) {
    state.heatersUrl.delete(heater);
  }
}
